
import { HttpDataService } from '../http/http-data.service';
import { Injectable } from '@angular/core';

export interface IMailRequest {
  to:string;
  cc:string;
  bcc:string;
  subject?:string;
  body:string;
}

@Injectable()
export class SendMailDataService {
  constructor(
    private httpDataService: HttpDataService
  ) {
    /**/
  }

  public sendMailToUsers = (data:IMailRequest): Promise<void> => {
    return this.httpDataService.doPOST(
      'rest/mail/send',
      undefined,
      data,
      undefined,
      'Error sending mail'
    );
  };
}